import { ModelTransformer } from '../../../../common/common.model';

export interface FractionColours {
    backgroundColour?: string;
    numeratorColour?: string;
    denominatorColour?: string;
}
export class FLWinningPerson {
    userId?: number;
    FLWinningPercentage?: number;
    FLWinningPercentageColour?: string;
    managerId?: number;
    firstName?: string;
    fullName?: string;
    userName?: string;
    winningNumber?: number;
    neutralNumber?: number;
    losingNumber?: number;
    total?: number;
    isSubordinate: boolean;
    bottomRole?: boolean;
    commitmentsAssessed?: number;
    isTop?: boolean;
    winning?: number;
    winningPer?: number;
    neutral?: string;
    losing?: string;
    dataRangeName: string;
    evaluationRangeName: string;
    winningThresholdColour: string;
    roleId?: number;
    role?: string;
    maxWinning?: number;
    maxLosing?: number;
    maxNeutral?: number;
    maxCommitmentsAssessed?: number;

    // for higher level
    subOrdinates?: FLWinningPerson[];
    isExpanded?: boolean;

    userDates?: WpHeaderDates[];
    hasData?: boolean;

    constructor(init?: Partial<FLWinningPerson>) {
        Object.assign(this, init);

        const t = Number(this.userId);

        if (typeof t !== 'number') {
            console.error('Invalid FLMI2Person.', this);
        }
    }
}

export class FLWinningMetric {
    managerId?: number;
    metricId?: number;
    metricInitials?: string;
    metricShortName?: string;
    metricName?: string;
    opportunityCount?: number;
    opportunityInIntervention?: number;
    coachedOpportunities?: number;
    missedOpportunities?: number;

    // calc
    uncoachedOpportunities?: number;
    metricBarMaxWidth?: number;
    topOpps?: number;
}

export class WpHeaderDates {
    userId?: number;
    dataRangeId?: number;
    startDateDataRange?: string;
    endDateDataRange?: string;
    evaluationRangeId?: number;
    createdOn?: string;
}
export class ExtFLWinningPersonTeam {
    userId?: number;
    userName?: string;
    winningNumber?: number;
    neutralNumber?: number;
    LosingNumber?: number;
    total?: number;
    bottomRole?: number;
    commitmentAssessed?: number;
    winning?: number;
    neutral?: string;
    losing?: string;
    dataRangeName: string;
    evaluationRangeName: string;
    winningThresholdColour: string;
    roleId?: number;

    // for higher level
    subOrdinates?: FLWinningPerson[];
    isExpanded?: boolean = false;
}

export class ExtFLWinningPerson {
    userId?: number;
    FLWinningPercentage?: number;
    FLWinningPercentageColour?: string;
    managerId?: number;
    firstName?: string;
    fullName?: string;
    userName?: string;
    winningNumber?: number;
    neutralNumber?: number;
    losingNumber?: number;
    total?: number;
    isSubordinate: boolean;
    bottomRole?: boolean;
    commitmentsAssessed?: number;
    isTop?: boolean;
    winning?: number;
    winningPer?: number;
    neutral?: string;
    losing?: string;
    dataRangeName: string;
    evaluationRangeName: string;
    winningThresholdColour: string;
    roleId?: number;
    role?: string;
    maxWinning?: number;
    maxLosing?: number;
    maxNeutral?: number;
    maxCommitmentsAssessed?: number;

    // for higher level
    subOrdinates?: FLWinningPerson[];
    isExpanded?: boolean;

    userDates?: WpHeaderDates[];
    hasData?: boolean;
}

function flattenObj<T, U = T>(obj: T, key: string): U[] {
    const flat = [];
    if (Object.prototype.hasOwnProperty.call(obj, key) === true) {
        obj[key]?.forEach((e) => {
            flat.push(e);
            flat.push(...flattenObj(e, key));
        });
    }
    return flat;
}
export class FLWinningTeamTransformer
    implements ModelTransformer<FLWinningPerson[], ExtFLWinningPersonTeam[]>
{
    private readonly _leaders: FLWinningPerson[];

    constructor(leader?: FLWinningPerson) {
        this._leaders =
            leader != null ? flattenObj(leader, 'subOrdinates') : [];
        leader != null && this._leaders.unshift(leader);
    }

    transform(model: ExtFLWinningPersonTeam[]): FLWinningPerson[] {
        const FLWinning: FLWinningPerson[] = [];

        model.forEach((g) => {
            const s: FLWinningPerson = {
                ...g,
                fullName: g.userName,
                bottomRole: g.bottomRole === 1,

                isSubordinate: true,
                isExpanded: false,
                isTop: false,
            };

            // percentage relative to manager's Funded Opportunities
            const leader = this._leaders.find((e) => e.userId === s.managerId);
            if (leader != null) {
                s.maxWinning = leader.winningNumber;
                s.maxLosing = leader.losingNumber;
                s.maxNeutral = leader.neutralNumber;
                s.maxCommitmentsAssessed = leader.commitmentsAssessed;
            }

            FLWinning.push(s);
        });

        return FLWinning;
    }
}

export class FLWinningTransformer
    implements ModelTransformer<FLWinningPerson, ExtFLWinningPerson>
{
    transform(model: ExtFLWinningPerson): FLWinningPerson {
        if (model.userId === null) return null;

        const winningperson = new FLWinningPerson({
            ...model,
            bottomRole: model.bottomRole === true,
            isTop: true,
        });
        return winningperson;
    }
}
